import {useCallback, useEffect, useRef} from "react";

/**
 * Defers an action until the tab becomes visible again.
 * If the tab is currently active, the action runs immediately.
 */
export const useDeferredSuccess = () => {
    const pendingRef = useRef<(() => void) | null>(null);

    useEffect(() => {
        if (typeof document === "undefined") {
            return;
        }
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && pendingRef.current) {
                const action = pendingRef.current;
                pendingRef.current = null;
                action();
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    return useCallback((action: () => void) => {
        if (typeof document !== "undefined" && document.hidden) {
            pendingRef.current = action;
        } else {
            action();
        }
    }, []);
};
